'use client';

import { AnchorTabs, anchorTabsTag } from '@ni/nimble-components/dist/esm/anchor-tabs';
import { wrap } from '../utilities/react-wrapper';

export { anchorTabsTag };
export { type AnchorTabs };
export const NimbleAnchorTabs = wrap(AnchorTabs);
